
import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import Container from './scenes'

const App: React.FC = (props: any) => {

  return (
    <Router>
      <Container/>
    </Router>
  );
}

export default App;